import React, { useState, useCallback } from 'react';
import { useExportsActions } from '../hooks/useExportsActions';
import { useCircles } from '../../search/hooks/useSearchState';
import { SearchSelect } from '../../../ui';
import ExportTemplate from './ExportTemplate';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const GroupsSelector = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
`

const GroupExports = () => {
  const { t } = useTranslation();
  const [selectedCircle, setSelectedCircle] = useState(null);

  const { circles } = useCircles({}, { skip: !localStorage.getItem('token') });
  const { userExport } = useExportsActions();

  const validCircles = circles?.filter(circle => circle && circle.id && circle.name) || [];

  const sendExport = useCallback(async (data) => {
    if (!selectedCircle) {
      return;
    }

    const exportData = {
      ...data,
      circleIds: [selectedCircle.id]
    }

    await userExport({ exportData });
  }, [userExport, selectedCircle]);

  return (
    <ExportTemplate sendExport={sendExport} selectedCircle={selectedCircle}
      additionalElement={
        <GroupsSelector>
          <SearchSelect
            options={validCircles}
            selectedOptions={selectedCircle}
            label={t('globals.group')}
            setValue={setSelectedCircle}
          />
        </GroupsSelector>}
    />
  );
}

export default GroupExports;
